import $ from 'jquery';
import selectize from 'selectize';
import '../vendor/selectizePreserveOnBlur';

function Institution($el){
	this.$el = $el;
	this.$form = $el.parents('form');
	this.$city = this.$form.find('[name="institution[0][city]"]');
	this.$address = this.$form.find('[name="institution[0][address]"]');
	this.redirectURL = this.$el.data('url') || false;
    this.enrolment = this.$el.data('enrolment') || false;
	this.field = this.$el.data('field') || false;
    const target = this.$el.data('target') || '[name="institution[0][uid]"]';
	this.$id = this.$form.find(target);
	this.$postcode = this.$form.find('[name="institution[0][postcode]"]');
	this.region = this.$el.data('region');
	this.init();
}

Institution.prototype = {

	init: function(){

		var options = {
			plugins: ['preserve_on_blur'],
			valueField: this.enrolment ? 'name' : 'uid',
			labelField: 'name',
			searchField: ['name','address','city','postcode'],
			load: $.proxy(this.load,this),
			hideSelected: true,
			render:{
				option: function(item,escape){
					return '<div class="suggestion">' +
					'<div class="suggestion__title">' + escape(item.name) + '</div>' +
					'<div class="suggestion__address">' + escape(item.address) + ', ' + escape(item.city) + '</div>' +
				'</div>';
				}
			}
		}

		if(this.enrolment){
		    this.$form.on('submit',this.onSubmit.bind(this))
        }

		if(this.$el.is('input')){
			options.maxItems = 1;
		}

		this.selectize = this.$el.selectize(options)[0].selectize;

		this.selectize.on('item_remove',this.onItemRemove.bind(this));
		this.selectize.on('item_add', this.onSelected.bind(this));
		window.selectize = this.selectize;
	},

	getRemoteUrl(query){

		const url = '/institutions/search';
		let params = [];
		if(this.field){
            params.push('field='+ this.field);
		}
        if(this.region){
            params.push('region='+ this.region);
        }
        params = params.join('&');
        params = params.length ? "?"+params : "";

		return url+'/' + query + params;
	},

	load(query,callback){

        if (query.length < 1) return callback();

        $.get(this.getRemoteUrl(query)).done(function(resp){
			callback(resp.data);
		});
	},
	onSelected(value){
		var data = this.selectize.options[value];
		if(this.redirectURL) {
            this.redirect(data);
        }
		if(this.enrolment){
            this.autocomplete(data);
        }
	},

	onItemRemove(value){
		this.selectize.removeOption(value);
		this.resetValues();
	},


	redirect(data){
        window.location = this.redirectURL.replace("{uid}",data.uid);
	},

	changeRegion(region,refresh){
		this.region = region;
		if(refresh){
			this.selectize.clearOptions();
			this.selectize.refreshOptions();
			this.selectize.clear();
		}

	},

	autocomplete(data){
		this.$city.val(data.city).prop('disabled',true);
		this.$address.val(data.address).prop('disabled',true);
		this.$postcode.val(data.postcode).prop('disabled',true);
		this.$id.val(data.uid);
		this.$id.trigger('change');
	},

	resetValues(){
		this.$city.prop('disabled',false).val('');
		this.$address.prop('disabled',false).val('');
		this.$postcode.prop('disabled',false).val('');
		this.$id.val('');
		this.$el.focus();
	},

    onSubmit(e){
        this.$city.prop('disabled',false);
        this.$address.prop('disabled',false);
        this.$postcode.prop('disabled',false);
    }

}

function init(){
	new Institution($(this));
}


$(document).ready(()=>{
	const $institution = $('[data-js-institution]');
	
	if($institution.length){
		$institution.each(init);
	}
})

export function create($el){
	return new Institution($el);
}
